import { useState } from "react";

import bg from '../assets/presentation.png';
import yt from '../assets/youtube.png';
import bb from '../assets/badboy.png';

const scriptUrl = "https://script.google.com/macros/s/AKfycbwUojj6IJk_Xm9Ok5lZIytx2vNoQwt9a-LZ0X5LL_teGHe9J92eQoIz1ZtIfCjK6QkI4Q/exec";

export const Presentation = () => {
  const [showForm, setShowForm] = useState(false);

  const onRegister = () => {
    setShowForm(true);
  }

  return (
    <div className="main bg-neutral-800">
      <header className="mt-3 md:mt-7 px-4 md:px-5 mb-5 md:mb-14 bg-neutral-800 bg-opacity-70">
        <div className="flex items-center justify-between wrapper">
          <a href="/" id="logo">
            <img className="w-14 lg:w-18 md:scale-150 origin-left" src="/logo.png" alt="IDM" />
          </a>
          <div className="menu px-2">
            <ul className="flex justify-between gap-x-5 md:gap-x-7 lg:gap-x-12 flex-nowrap">
              <li className="py-2 md:py-5">
                <a href="https://idm.ua/about-idm" className="font-bold md:text-xl text-white">Про IDM</a>
              </li>
              <li className="py-2 md:py-5">
                <a href="https://idm.ua" className="font-bold md:text-xl text-white">Основний Сайт</a>
              </li>
              <li className="py-2 md:py-5">
                <a href="https://www.youtube.com/watch?v=oBILezkWJoI" target="_blank" rel="noreferrer">
                  <img className="w-8 md:w-9 md:mx-1" src={yt} alt="youtube" />  
                </a>
              </li>
            </ul>
          </div>
        </div>
      </header>

      <main className="px-5 pb-8">
        <div className="wrapper">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold text-[#fff042] uppercase mb-4">
              Сучасні <br className="sm:hidden"/>можливості <br className="sm:hidden"/>теплових насосів
            </h2>
            <p className="text-[22px] text-neutral-100">Закрита презентація для архітекторів та дизайнерів</p>
            <span className="block h-[1px] my-5 md:my-8 bg-yellow-300 bg-opacity-70"></span>

            <div className="flex flex-col gap-y-3 md:flex-row-reverse">   
              <img className="md:w-1/2 -mx-5 md:mx-0 max-w-max" src={bg} alt="presentation" />

              <div className="flex flex-col md:w-1/2 md:p-2">
                <p className="text-lg text-[#fff042] mb-1">12 червня 2025, 11:00</p>
                <p className="text-lg text-neutral-100 md:mb-5">
                  Львів, вул. Княгині Ольги, 95 (ТЦ Mark)
                </p> 
                <span className="block md:hidden h-[2px] my-3 bg-yellow-300 bg-opacity-50"></span>
                <a href="mailto:lviv@neoteplo.com.ua" className="text-lg text-neutral-100 mb-1">lviv@neoteplo.com.ua</a>
                <a href="tel:+38 067-495-71-79" className="text-lg text-neutral-100 mb-8">+38 067-495-71-79</a>

                <button className="md:w-3/4 btn btn-primary mt-auto" onClick={onRegister}>ЗАРЕЄСТРУВАТИСЬ</button>
              </div>
            </div>

            <div className="flex gap-x-5 items-center justify-center mt-8 md:mt-10">
              <a className="flex-shrink-0" href="https://badboy.ua" target="_blank" rel="noreferrer">
                <img className="w-11" src={bb} alt="BadBoy" />
              </a>
              <p className="text-neutral-200 text-center text-sm md:text-base mt-2 md:mt-3.5">
                Учасників презентації чекає розіграш <br className="md:hidden"/>сертифікату з мережі магазинів BAD BOY
              </p>
            </div>
          </div>
        </div>
      </main>

      {showForm && (
        <Form setShow={setShowForm}/>
      )}
    </div>
  );
};

const Form = ({ setShow }: { 
  setShow: (show: boolean) => void 
}) => {
  const [name, setName] = useState("");
  const [company, setCompany] = useState("");
  const [phone, setPhone] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: any) => {
    const data = new FormData(e.target);
    e.preventDefault();
    setError("");
    setLoading(true);

    fetch(scriptUrl, {
      method: "POST",
      body: data,
    }).then((res) => {
      if (res.ok) {
        setSubmitted(true);
        clearValues();
      } else {
        setError("Помилка відправки");
      }
    })
    .catch(() => setError("Помилка з'єднання"))
    .finally(() => setLoading(false));
  };

  const clearValues = () => {
    setName("");
    setCompany("");
    setPhone("");
  }

  const onClose = () => {
    setShow(false);
  }

  return (
    <div className="modal">
      <div className="modal-box md:mt-14 px-5 py-7 md:p-8 bg-[#fff042]">
        <h3 className="text-2xl font-bold mb-7">РЕЄСТРАЦІЯ</h3>
        <button onClick={onClose} className="absolute top-6 md:top-4 right-4">
          <svg width="32" height="32" viewBox="0 0 512 512" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"><g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd"><g id="Combined-Shape" fill="#000000" transform="translate(91.581722, 91.581722)"><path d="M298.666667,4.26325641e-14 L328.836556,30.1698893 L194.587,164.418 L328.836556,298.666667 L298.666667,328.836556 L164.418,194.587 L30.1698893,328.836556 L9.9475983e-14,298.666667 L134.248,164.418 L7.10542736e-14,30.1698893 L30.1698893,4.26325641e-14 L164.418,134.248 L298.666667,4.26325641e-14 Z" transform="translate(164.418278, 164.418278) rotate(-360.000000) translate(-164.418278, -164.418278) "></path></g></g></svg>
        </button>

        <form onSubmit={handleSubmit}>
          <div className="mb-5">
            <label htmlFor="company">Назва компанії:</label>
            <input
              type="text"
              id="company"
              name="company"
              required
              placeholder="Ваша компанія"
              value={company}
              onChange={(e) => setCompany(e.target.value)}
            />
          </div>
          <div className="mb-5">
            <label htmlFor="name">Ім'я:</label>
            <input
              type="text"
              id="name"
              name="name"
              required
              placeholder="Введіть своє ім'я"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>
          <div>
            <label htmlFor="phone">Телефон:</label>
            <input
              type="tel"
              id="phone"
              name="phone"
              required
              placeholder="+38 (067) 495-71-79"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
          </div>
          <div className="relative flex items-center h-[52px] mt-14 md:mt-10">
            {!submitted && (
              <button type="submit" disabled={loading} className="btn btn-secondary">ВІДПРАВИТИ</button>
            )}
            {error && <p className="text-red-600 font-semibold absolute right-2 md:right-auto md:left-1/2 md:-translate-x-1/2">{error}</p>}
            {submitted && <p className="text-emerald-500 font-semibold w-full text-center">Успішно відправлено!</p>}
          </div>
        </form>
      </div>
    </div>
  )
}